// @flow
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import RoundedButton from './RoundedButton';

const useStyles = makeStyles({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minWidth: 72,
    height: 56,
    marginLeft: 8,
    marginRight: 8,
    fontSize: 16,
    fontWeight: 400,
  },
});

interface Props {
  children: Object;
  className?: string;
  color: string;
  icon: Object;
  onClick: Function;
  sidebarOpen: boolean;
}

const SidebarButton = ({ children, className, color, icon, onClick, sidebarOpen }: Props) => {
  const classes = useStyles();

  const [textVisible, setTextVisible] = useState(true);
  const [centerContent, setCenterContent] = useState(false);

  useEffect(() => {
    if (sidebarOpen) {
      setCenterContent(false);
      setTimeout(() => setTextVisible(true), 200);
    } else {
      setTextVisible(false);
      setTimeout(() => setCenterContent(true), 180);
    }
  }, [sidebarOpen]);

  return (
    <RoundedButton
      className={classnames(classes.button, className)}
      style={{ paddingLeft: centerContent ? 8 : 20 }}
      color={color}
      centered={centerContent}
      onClick={onClick}
      disableRipple
    >
      {icon}
      {textVisible && children}
    </RoundedButton>
  );
};

const mapStateToProps = ({ scribeSession: { sidebar } }) => ({ sidebarOpen: sidebar });

export default connect(mapStateToProps)(SidebarButton);
